import { render, staticRenderFns } from "./JoyfulMovement.vue?vue&type=template&id=7b70b1a8&scoped=true&"
import script from "./JoyfulMovement.vue?vue&type=script&lang=js&"
export * from "./JoyfulMovement.vue?vue&type=script&lang=js&"
import style0 from "./JoyfulMovement.vue?vue&type=style&index=0&id=7b70b1a8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b70b1a8",
  null
  
)

export default component.exports